import { render, staticRenderFns } from "./IAPController.vue?vue&type=template&id=1c224212&"
import script from "./IAPController.vue?vue&type=script&lang=js&"
export * from "./IAPController.vue?vue&type=script&lang=js&"
import style0 from "./IAPController.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports